import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}

/** Aparición al entrar en pantalla (una sola vez). */
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  const reduce = useReducedMotion();
  return <motion.div className={className} initial={reduce ? false : {
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1],
    delay
  }} data-id="element-1130" data-mp="thhq4eaend05">
      {children}
    </motion.div>;
}